import ActionButton from "@/components/Button/ActionButton";
import { DataTable } from "@/components/DataTable";
import { FillScreen, HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useState } from "react";
import { InventoryTabs, useInventoryTabs } from "./-components/InventoryTabs";
import { DeviceAssignmentDialog } from "./-components/device-assignment-dialog";
import { SearchSchema } from "./-constants";
import { useLicenseDeviceTable } from "./-hooks/useLicenseDeviceTable";

export const Route = createFileRoute(
  "/_staff/licenses/$id/_profile/assignments/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: LicenseDevices,
});

function LicenseDevices() {
  const { id } = Route.useParams();
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.licenses.detailDevices",
  });

  // const navigate = useNavigate({ from: "/licenses/$id/devices" });
  // const search = Route.useSearch();

  const { table, displayState, counts, allocationType } =
    useLicenseDeviceTable();

  // const handleFilterInput = useDebouncedCallback(
  //   (e: ChangeEvent<HTMLInputElement>) =>
  //     navigate({
  //       search: (prev) => ({ ...prev, pageIndex: 0, freeText: e.target.value }),
  //     }),
  //   [navigate],
  // );
  const inventoryTabsProps = useInventoryTabs();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <InventoryTabs
          counts={counts}
          onChange={inventoryTabsProps.onChange}
          value={inventoryTabsProps.value}
        />
        {allocationType === "DEVICE_BASED" && (
          <>
            <span className="ml-auto">
              <ActionButton
                variant="secondary"
                size="sm"
                onClick={() => setIsOpen(true)}
              >
                {t("assignButton")}
              </ActionButton>
            </span>
            <DeviceAssignmentDialog
              licenseId={id}
              title={t("deviceAssignmentDialog.title")}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              onSuccess={() => {}}
            />
          </>
        )}
      </HStack>
      <DataTable table={table} displayState={displayState} />
    </FillScreen>
  );
}
